import ApiService from "../api.services";

const ServicesGroupService = {
  list: async function (customer) {
    try {
      const response = await ApiService.get(
        `/api/servicegroup?customer=${customer || ""}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async function (id) {
    try {
      const response = await ApiService.get(`/api/servicegroup/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  add: async function (form, services) {
    try {
      const data = {
        servicegroup: form,
      };
      data.servicegroup.services = services;
      const res = await ApiService.post("/api/servicegroup", data);
      return res.data;
    } catch (error) {
      throw error;
    }
  },
  update: async function (id, form, services) {
    const data = {
      servicegroup: form,
    };
    data.servicegroup.services = services;
    try {
      const response = await ApiService.put(`/api/servicegroup/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async function (id) {
    try {
      const response = await ApiService.delete(`/api/servicegroup/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default ServicesGroupService;

export { ServicesGroupService };
